import { FormPage } from '@checkit/react-components';
import { AddIcon } from '@checkit/react-components/build/components/Icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';
import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import {
  createUserDefinedRole,
  isCreateUserDefinedRoleSuccess
} from '../actions';
import { UserDefinedRoleForm } from '../form/UserDefinedRoleForm';
import { UserDefinedRoleCreateDto } from '../state';
import { messages } from './NewUserDefinedRole.translations';

export const NewUserDefinedRole: React.FC<RouteComponentProps> = ({ history }) => {
  const { formatMessage } = useIntl();
  const dispatch = useAxiosDispatch( );

  async function handleSubmit(data: UserDefinedRoleCreateDto): Promise<AnyAction>  {
    const resultingAction = await dispatch(createUserDefinedRole(data));

    if (isCreateUserDefinedRoleSuccess(resultingAction)) {
        dispatch(createSnackbar({
          message: formatMessage(messages['userDefinedRole.new.success']),
          options: { variant: 'success' }
        }));
    } else {
        const errorType = (resultingAction as any).error ? (resultingAction as any).error.response.data.message : null;
        if (errorType && errorType === messages['userDefinedRole.new.error.duplicate'].id) {
          dispatch(createSnackbar({
            message: formatMessage(messages['userDefinedRole.new.error.duplicate']),
            options: { variant: 'error' }
          }));
        } else {
          dispatch(createSnackbar({
            message: formatMessage(messages['userDefinedRole.new.error']),
            options: { variant: 'error' }
          }));
        }
    }
    return resultingAction;
  }

  return (
    <FormPage pageTitle={formatMessage(messages['userDefinedRole.new.pageTitle'])} pageIcon={<AddIcon />}>
      <UserDefinedRoleForm code={null} history={history} handleSubmit={handleSubmit} />
    </FormPage>
  );
};
